module.exports = __webpack_public_path__ + "public/SiteIcons/selectedDarkIcon.svg?e43f6f3c";